// Port of api/fuel/app/classes/controller/api/monty/games/about.php
import { buildAboutResponse } from 'offline/api/games/shared'

export default function(params) {
	return buildAboutResponse(params)
}
